import { Skeleton } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAttributeGroup } from '@/entities/attributes';
import { AttributeGroupForm } from './AttributeGroupForm/AttributeGroupForm';

type Props = {
  entityId?: string;
  onUnsavedChange?: (hasUnsaved: boolean) => void;
};

export const AttributeGroupCard: FC<Props> = ({ entityId, onUnsavedChange }) => {
  const { t } = useTranslation('attributeGroups');
  const isCreateMode = entityId === 'create';
  const code = isCreateMode ? undefined : entityId;

  const { data: entity, isLoading } = useAttributeGroup(code);

  if (isLoading) {
    return <Skeleton className="h-full" />;
  }

  if (entity || isCreateMode) {
    return <AttributeGroupForm key={entity?.code ?? 'create'} initial={entity} onUnsavedChange={onUnsavedChange} />;
  }

  return <div className="flex items-center justify-center h-full text-muted-foreground">{t('selectGroup')}</div>;
};
